import { css, unsafeCSS } from 'lit';
export const fontStyle = (targetName = '') => css `
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('fonts/Inter/Inter-Medium.woff2') format('woff2');
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('fonts/Inter/Inter-SemiBold.woff2') format('woff2');
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('fonts/Inter/Inter-Regular.woff2') format('woff2');
  }

  ${unsafeCSS(targetName)} * {
    font-family: 'Inter', sans-serif;
    font-style: normal;
  }
`;
//# sourceMappingURL=font.style.js.map